import { useEffect } from "react";
import useRouter from "found/useRouter";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import useTracking from "common/hooks/useTracking";

import { backEndRequest } from "common/request";

const request = backEndRequest();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
  })
);

export default function EmailPublicationDownload() {
  const classes = useStyles();
  const { match } = useRouter();
  const subscriptionId = match?.params?.subscriptionId || "";
  const { handlePushEvent } = useTracking();
  const baseURL = process.env.REACT_APP_API_DOMAIN;

  useEffect(() => {
    document.title = "Publication Download";

    const handleTrackingAndRedirectToDownload = async () => {
      try {
        const { data: subscription } = await request.get(
          `/wm/subscription/${subscriptionId}`
        );
        const { user, account, publication } = subscription;

        const userParams: any = {};

        Object.keys(user).forEach((keyParam) => {
          const key = `user.${keyParam}`;

          userParams[key] = user[keyParam];
        });

        userParams["user.companySalesforceId"] = account?.salesforceId;

        handlePushEvent(
          "emailPublicationDownloadPdf",
          {
            ...userParams,
            id: publication.id,
            title: publication.title,
            fileName: publication.fileName,
            source: "mail",
          },
          true
        );

        window.location.replace(`${baseURL}/wm/mail/${subscriptionId}`);
      } catch (error) {
        console.error(error);
        window.location.replace(`/publications`);
      }
    };

    if (subscriptionId) {
      handleTrackingAndRedirectToDownload();
    }
  }, [subscriptionId]);

  return (
    <Backdrop open className={classes.backdrop}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
